import React from 'react';
import { Layout, Menu } from 'antd';
import { useNavigate } from 'react-router-dom';
import './Header.css'; // Import the CSS file

const { Header } = Layout;

const AppHeader = ({ userName, handleLogout }) => {
    const navigate = useNavigate();

    const handleMenuClick = (e) => {
        if (e.key === 'logout') {
            handleLogout();
        } else {
            navigate(e.key);
        }
    };

    return (
        <Header>
            <Menu theme="light" mode="horizontal" onClick={handleMenuClick}>
                {userName ? (
                    <>
                        <span className="user-name">
                            {userName}
                        </span>
                    </>
                ) : (
                    <Menu.Item key="/login">
                        登入
                    </Menu.Item>
                )}
                <Menu.Item key="/borrow">借用<br/>Borrow</Menu.Item>
                <Menu.Item key="/borrow-history">借用紀錄<br/>History</Menu.Item>
                <Menu.Item key="/machine-status">機器狀態<br/>Machine Status</Menu.Item>
                {userName ? (
                    <Menu.Item key="logout">
                    登出 <br/> Logout
                </Menu.Item>
                ) : null}
            </Menu>
        </Header>
    );
};

export default AppHeader;